import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import RidGenerator from 'utils/swarm/rid-generator';
import { TMarketCountResponse } from 'interfaces/sportsbook';
import { executeCommand, unsubscribeCommand } from 'services/get-data-level';
import { setMarketsCount } from 'store/actions/new-sportsbook';
import { getMarketsCount } from 'store/selectors/new-sportsbook';

type TUseGetMarketsCountsProps = {
  gameIds: number[] | null;
  reduxKey: string;
};

type TUseGetMarketsCountsReturnValue = {
  marketsCounts: Record<string, number>;
};

export const useGetMarketsCounts = ({
  gameIds,
  reduxKey
}: TUseGetMarketsCountsProps): TUseGetMarketsCountsReturnValue => {
  const dispatch = useDispatch();

  const marketsCounts = useSelector(getMarketsCount)[reduxKey];

  useEffect(() => {
    if (SpringConfigs.MOCKED_DATA) {
      return;
    }

    if (gameIds?.length) {
      const marketsCountRid = RidGenerator.gForSubscribe('marketsCountRid');

      const what = {
        market: '@count',
        game: ['id']
      };

      const where = {
        game: {
          id: {
            '@in': gameIds
          }
        }
      };

      const updateMarketsCount = (resp: TMarketCountResponse) => {
        if (resp?.game) {
          const markets = Object.values(resp.game).reduce(
            (result: Record<string, number>, { id, market }) => {
              result[id] = market;

              return result;
            },
            {}
          );

          dispatch(setMarketsCount({ [reduxKey]: markets }));
        }
      };

      executeCommand(
        marketsCountRid,
        what,
        where,
        updateMarketsCount,
        true,
        updateMarketsCount
      );

      return () => {
        if (gameIds?.length) {
          unsubscribeCommand(marketsCountRid);
        }
      };
    }
  }, [gameIds?.join('')]);

  return {
    marketsCounts: SpringConfigs.MOCKED_DATA ? {} : marketsCounts
  };
};
